import { render, staticRenderFns } from "./DeliverySuccessRate.vue?vue&type=template&id=6391bc8e"
import script from "./DeliverySuccessRate.vue?vue&type=script&lang=js"
export * from "./DeliverySuccessRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports